import React, { useCallback } from 'react';
import {
  Radio,
  RadioGroupMinimal,
} from '@lifeomic/chroma-react/components/Radio';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  timeScalePickerLabel: {
    id: 'timeScalePicker.label',
    defaultMessage: 'Time scale picker',
  },
});

export type TimeScale = 'm' | '6m' | 'y' | '5y';

const options = [
  {
    label: 'M',
    value: 'm',
  },
  {
    label: '6M',
    value: '6m',
  },
  {
    label: 'Y',
    value: 'y',
  },
  {
    label: '5Y',
    value: '5y',
  },
];

type TimeScalePickerProps = {
  selectedScale: TimeScale;
  onSelect: (scale: TimeScale) => void;
};

export const TimeScalePicker = ({
  selectedScale,
  onSelect,
}: TimeScalePickerProps) => {
  const { formatMessage } = useIntl();

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onSelect(e.target.value as TimeScale);
    },
    [onSelect],
  );

  return (
    <RadioGroupMinimal
      value={selectedScale}
      direction="row"
      onChange={onChange}
      aria-label={formatMessage(messages.timeScalePickerLabel)}
      fullWidth
    >
      {options.map(option => (
        <Radio key={option.value} label={option.label} value={option.value} />
      ))}
    </RadioGroupMinimal>
  );
};
